import React from 'react';

import SCIs from '../../components/Monitoring/SCIs/SCIs';

function SCIsView() {
  return (
    <SCIs />
  );
}

export default SCIsView;
